import { useState } from 'react';
import { animated, useSpring } from 'react-spring';
import {
  Box, makeStyles,
  Typography,
} from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import PropTypes from 'prop-types';

import InitModal from './InitModal';
import ModalCourseInfo from './ModalCourseInfo';
import SideBar from './Sidebar';

const useStyles = makeStyles((theme) => ({
  titleContainer: {
    position: 'absolute',
    top: '3%',
    left: '40%',
    zIndex: 100,
  },
  titleText: {
    fontFamily: 'Raleway',
    color: theme.palette.text.default,
    fontWeight: 600,
    fontSize: '40px',
    textTransform: 'uppercase',
  },
  buttonSidebar: {
    position: 'absolute',
    zIndex: 100,
    top: '40%',
    width: '50px',
    height: '100px',
    borderRadius: '0 100px 100px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.background.default,
    background: theme.palette.background.secondary,
  },
  drawer: {
    position: 'relative',
    zIndex: 100,
    background: theme.palette.background.default,
  },
  kamiContainer: {
    zIndex: 100,
    position: 'absolute',
    bottom: '0',
    right: '0',
    background: 'none',
    width: '200px',
    height: '200px',
  },
  returnButton: {
    position: 'absolute',
    zIndex: 100,
    top: '4%',
    left: '2%',
  },
}));
function AccessoriesContainer({ showValue, loading }) {
  const classes = useStyles();
  const showSessionValue = sessionStorage.getItem('noneInit');
  const [drawer, setDrawer] = useState(false);

  const buttonDrawer = useSpring({
    from: {
      position: 'absolute',
      zIndex: 100,
      top: '40%',
      left: '0',
      width: '50px',
      height: '100px',
      borderRadius: '0 100px 100px 0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#ffffff',
      background: '#CE0F65',
    },
    left: '20%',
    config: { mass: 1, tension: 210, friction: 20 },
    reverse: !drawer,
  });
  const drawerOpenStyle = useSpring({
    from: { display: 'none', width: '0' },
    to: {
      display: 'block',
      position: 'absolute',
      zIndex: 100,
      width: '305px',
      minHeight: '100vh',
      background: '#ffffff',
    },
    config: { mass: 1, tension: 210, friction: 20 },
    reverse: !drawer,
  });
  const handleOpenDrawer = () => {
    setDrawer(!drawer);
  };
  return (
    <div
      className="containerSceneMap"
      style={{ display: showSessionValue !== undefined ? 'block' : 'none' }}
    >
      {showValue === true || showSessionValue === 'true' ? (
        <Box className={classes.titleContainer}>
          <Typography className={classes.titleText}>Innovation World</Typography>
        </Box>
      ) : null}
      {showValue && !window.location.pathname.includes('theme') ? (
        <Box>
          <InitModal showValue={showValue} loading={loading} />
        </Box>
      ) : null}
      <Box
        style={{
          display:
            showValue === true || showSessionValue === 'true'
              ? 'block'
              : 'none',
        }}
      >
        <animated.div style={buttonDrawer} onClick={handleOpenDrawer}>
          {drawer ? <ArrowBackIosIcon /> : <ArrowForwardIosIcon />}
        </animated.div>
        <animated.div style={drawerOpenStyle}>
          <SideBar />
        </animated.div>
      </Box>
      {window.location.pathname.includes('theme') ? (
        <Box>
          <ModalCourseInfo />
        </Box>
      ) : null}
    </div>
  );
}

export default AccessoriesContainer;

AccessoriesContainer.propTypes = {
  showValue: PropTypes.bool.isRequired,
  loading: PropTypes.func.isRequired,
};
